exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table th[data-v-58b1c6a4],\n.table td[data-v-58b1c6a4] {\n  border-top: none !important;\n  border-bottom: none !important;\n  padding: 4px !important;\n}\n", ""]);

// exports
